import axios from 'axios';
import {
    WEEX_LANG_UPDATE_DISK,
    WEEX_LANG_UPDATE_TIMESTAMP_DISK,
    WEEX_LANG_BASE_TIMESTAMP,
    WEEX_LANG_SYSTEM,
    WEEX_LANG_APP
} from './config';
import baseLangs from './base';
import CommonUtils from '../utils';

/**
 * 获取当前语言文案
 * @param {String} lang 语言代码
 * @returns {Map<String, any>}
 */
export default async function getLanguageByCode(lang) {
    const languageCode = CommonUtils.handleLangCode(lang);
    console.log('languageCode', languageCode);

    // 读取本地基础包 & localStorage增量包；同时异步查询增量更新
    let languageObj = baseLangs[languageCode] || {};

    let updateDisk = localStorage.getItem(WEEX_LANG_UPDATE_DISK);
    updateDisk = updateDisk || {};
    try {
        updateDisk = JSON.parse(updateDisk);
    } catch (error) {
        console.log(error);
    }
    const updateDiskCurrentLang = updateDisk[languageCode] || {};

    // 合并基础包 & 增量包
    languageObj = {
        ...languageObj,
        ...updateDiskCurrentLang
    };

    // 增量更新时间戳
    let updateTimestamp = localStorage.getItem(WEEX_LANG_UPDATE_TIMESTAMP_DISK);
    updateTimestamp = updateTimestamp || {};
    try {
        updateTimestamp = JSON.parse(updateTimestamp);
    } catch (error) {
        console.log(error);
    }
    const updateTimestampCurrentLang = updateTimestamp[languageCode];
    console.log('updateTimestampCurrentLang', updateTimestampCurrentLang);

    let userInfo = {};
    // APP中查询用户信息
    // if (window.bridge && window.bridge.getUserInfoAsync) {
    //     userInfo = await window.bridge.getUserInfoAsync();
    //     console.log('getLanguageByCode: userInfo', userInfo);
    // }
    
    // 查询增量更新，并更新到localStorage增量包，同时更新增量包时间戳
    axios({
        method: 'post',
        url: `${CommonUtils.masBaseURL()}/multilang/app/query`,
        data: {
            email: userInfo.email || '',
            time: updateTimestampCurrentLang || WEEX_LANG_BASE_TIMESTAMP,
            system: WEEX_LANG_SYSTEM,
            app: WEEX_LANG_APP,
            langCode: languageCode
        }
    })
        .then((response) => {
            try {
                const res = response.data;
                if (res.code === 0) {
                    const list = res.data.list;

                    let updateLangs = {};
                    list.forEach((item) => {
                        const langValue = Object.values(item)[0];
                        updateLangs = {
                            ...updateLangs,
                            ...langValue
                        };
                    });

                    // 白名单用户，合并未生效数据
                    if (res.data.whiteList && Object.keys(res.data.whiteList).length > 0) {
                        updateLangs = {
                            ...updateLangs,
                            ...res.data.whiteList
                        };
                    }

                    // 更新localStorage增量包
                    localStorage.setItem(
                        [WEEX_LANG_UPDATE_DISK],
                        JSON.stringify({
                            ...updateDisk,
                            [languageCode]: {
                                ...updateDiskCurrentLang,
                                ...updateLangs
                            }
                        })

                    );

                    // 更新时间戳
                    if (list.length > 0) {
                        const latestTimestamp = Object.keys(list[list.length - 1])[0];
                        console.log('latestTimestamp', latestTimestamp);

                        localStorage.setItem([WEEX_LANG_UPDATE_TIMESTAMP_DISK], JSON.stringify({
                            ...updateTimestamp,
                            [languageCode]: latestTimestamp
                        }));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        })
        .catch((error) => {
            console.log(error);
        });

    return languageObj;
}
